import { currency } from '@filters/shared-filters';

export const annualRecurringThreshold = currency(25000, 0);
export const yearlyOneTimeThreshold = currency(3000, 0);
